import { useEffect, useState } from "react";
import { callApiAsync, getStrategyAndDofas } from "../../services/apiService";
import ShowTable from "../tables/showTable";
import { strategiesTypeEnum } from "../../constants/enums";

const StrategyRelationsTable = ({ strategyId }) => {
  const [strategyData, setStrategyData] = useState({});
  const [nameStrategies, setNameStrategies] = useState({
    select1: "",
    select2: ""
  });
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    switch (strategyData?.type) {
      case strategiesTypeEnum.growth:
        setNameStrategies({
          select1: "Fortalezas",
          select2: "Oportunidades"
        });
        break;
      case strategiesTypeEnum.redirect:
        setNameStrategies({
          select1: "Debilidades",
          select2: "Oportunidades"
        });
        break;
      case strategiesTypeEnum.protection:
        setNameStrategies({ select1: "Fortalezas", select2: "Amenazas" });
        break;
      case strategiesTypeEnum.survive:
        setNameStrategies({ select1: "Debilidades", select2: "Amenazas" });
        break;
      default:
        break;
    }
  }, [strategyId, strategyData]);

  const getStrategiesDofaBannerData = async (id) => {
    await callApiAsync(
      () => getStrategyAndDofas(id),
      (response) => {
        setStrategyData(response.strategy);
        setTableData(response.table);
      }
    );
  };

  useEffect(() => {
    getStrategiesDofaBannerData(strategyId);
  }, [strategyId]);

  const columns = [
    {
      field: "name",
      header: "",
      align: "left",
      sortable: true,
      width: "70px"
    },
    {
      field: "description",
      header: nameStrategies.select1,
      align: "left",
      sortable: false,
      tooltipField: "description",
      width: "300px"
    },
    {
      field: "name_2",
      header: "",
      align: "left",
      sortable: true,
      width: "70px"
    },
    {
      field: "description_2",
      header: nameStrategies.select2,
      align: "left",
      sortable: false,
      tooltipField: "description_2",
      width: "300px"
    }
  ];

  return (
    <div style={{ marginTop: 20 }}>
                    
      <ShowTable data={tableData} columns={columns} showTooltips={true}/>
    </div>
  );
};

export default StrategyRelationsTable;
